import { Table, TableProps } from '@otp/ui';
import { useTranslation } from 'react-i18next';
import { getTableConfig, MostFavourite } from './config';
import { PartialMostFavouriteListType } from 'src/components/most/list/favourite/types';

type MostFavouriteTableProps = Omit<TableProps, 'columns'> & {
  data: PartialMostFavouriteListType[];
};

export const MostFavouriteTable = ({
  data,
  ...props
}: MostFavouriteTableProps) => {
  const { t } = useTranslation();

  const tableConfig = getTableConfig(data || [], { t });

  return <Table {...props} data={data} columns={tableConfig} />;
};
